import UserDetail from "../../../components/User/UserDetail/UserDetail";
import VerificationStatusCard from "../../../components/User/UserDetail/VerificationStatusCard";
import VerificationServiceCards from "../../../components/User/UserDetail/VerificationSteps/VerificationServiceCards";
import { VerificationStepType } from "../../../enums/VerificationStepType";
import clientUserStore from "../../../stores/clientUser.store";
import { getUserVerificationStepStatus } from "../../../utils/User.util";
import { getVerificationStepUserServices } from "../../../helpers/VerificationService.helper";
import { verificationStepTitle } from "../../../utils/VerificationSteps.util";
import { observer } from "mobx-react";
import UserVerificationServiceDto from "../../../interfaces/user/verification-service.dto";
import VerificationStepSettings from "../../../components/User/UserDetail/VerificationSteps/VerificationStepSettings";
import { stepConfigStore } from "../../../utils/FlowConfig.util";
import CompanyInfoData from "../../../components/User/UserDetail/CompanyInfo/CompanyInfoData";
import { useParams } from "react-router-dom";
import { useEffect } from "react";

function UserDetailCompanyInfo() {
  const stepType = VerificationStepType.COMPANY_INFO;
  const companyInfo = clientUserStore.user?.companyInfo;

  let services: UserVerificationServiceDto[] = [];

  const { user } = useParams();
  useEffect(() => {
    if (user) {
    //   clientUserStore.resetUser();
      clientUserStore.getUser({ user, properties: [stepType] });
    }
  }, [user]);

  if (companyInfo) {
    services = getVerificationStepUserServices({
      configServices: stepConfigStore(
        clientUserStore.user?.flowType
      ).getVerificationServices(stepType),
      userServices: companyInfo.services ? companyInfo.services : [],
    });
  }

  const renderCompanyInfoData = () => {
    return (
      <VerificationStatusCard
        title={verificationStepTitle(stepType)}
        status={getUserVerificationStepStatus({
          user: clientUserStore.user!,
          step: stepType,
        })}
        rightTopItem={
          companyInfo && <VerificationStepSettings step={stepType} />
        }
      >
        {companyInfo && <CompanyInfoData companyInfo={companyInfo} />}
      </VerificationStatusCard>
    );
  };

  return (
    <UserDetail>
      <>
        {renderCompanyInfoData()}
        {companyInfo &&
          (services && services.length > 0 ? (
            <VerificationServiceCards
              className="mt-8"
              services={services}
              comments={companyInfo.comments}
              stepType={stepType}
            />
          ) : (
            <></>
          ))}
      </>
    </UserDetail>
  );
}

export default observer(UserDetailCompanyInfo);
